/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  math.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:28
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/**
 * 根据mathjs封装计算方法
 */
import * as math from 'mathjs';

export default {
    // 加
    mathAdd(num1, num2) {
        return math.add(math.bignumber(num1), math.bignumber(num2));
    },
    // 乘
    mathMultiply(num1, num2) {
        return math.multiply(math.bignumber(num1), math.bignumber(num2));
    },
    // 减
    mathSubtract(num1, num2) {
        return math.subtract(math.bignumber(num1), math.bignumber(num2));
    },
    // 除
    mathDivide(num1, num2) {
        return math.divide(math.bignumber(num1), math.bignumber(num2));
    }
}
